import CloseIcon from "../icons/CloseIcon";
import styles from "./CloseButton.module.css";

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

export default function CloseButton({ onClick, ariaLabel = "Close" }: CloseButtonProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={styles.closeButton}
    >
      <CloseIcon />
    </button>
  );
}
